import styled from "@emotion/styled";
import { BASE_COLORS, FONT_SIZES } from "../../../../../../../../../../emotion-theme";

export const ProductBox = styled.div`
  position: relative;
  display: flex;
  border: solid 1px ${BASE_COLORS.lightGrey};
  border-radius: 4px;
  padding: 4px;
  overflow: hidden;
`;
export const ProductInfo = styled.div`
  width: 100%;
`;
export const ProductInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px;
  width: 100%;
`;
export const ProductInfoDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const ProductName = styled.h2<{ active: boolean }>`
  display: block;
  margin: 0;
  padding: 0 44px 8px 0;
  color: ${(props) => (props.active ? BASE_COLORS.grey : BASE_COLORS.red)};
  font-size: ${FONT_SIZES.large};
`;
export const ProductDetail = styled.div`
  padding: 4px;
  font-size: ${FONT_SIZES.body};
  font-weight: 200;
  margin: 0;
  flex-grow: 1;
`;
export const ProductDetailTitle = styled.h3`
  display: block;
  margin: 0;
  padding: 0 0 4px 0;
  width: 100%;
  font-weight: normal;
  font-size: ${FONT_SIZES.body};
  color: ${BASE_COLORS.grey};
  white-space: nowrap;
`;
export const ProductValue = styled.div`
  font-weight: 700;
`;
export const HeaderLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
